// extracted by mini-css-extract-plugin
export default {"card":"FeatureCard_card__zKKLZ","avatar":"FeatureCard_avatar__IOIbD","button":"FeatureCard_button__jJ+oN"};